import { Component, OnInit } from '@angular/core';
import { Permission } from '@core/configs/permissions';
import { UserProfileService } from '__services/user-profile.service';

@Component({
  selector: 'app-account-role',
  templateUrl: './account-role.component.html',
  styleUrls: ['./account-role.component.scss']
})
export class AccountRoleComponent implements OnInit {
  roleFeatures = [];
  displayedColumns: string[] = ['name', 'create', 'retrieve', 'update', 'delete', 'validate', 'override'];
  constructor(
    private userProfileService: UserProfileService,
  ) { }

  ngOnInit(): void {
      const userFeatures = this.userProfileService.getUserFeatures();
      if(userFeatures) {
        this.checkRoleFeatures(userFeatures);
      }
  }

  checkRoleFeatures(userFeatures) {
    this.roleFeatures = userFeatures.map(module => {
      module.features = module.features.map(feature => {
        const {name, perms} = feature
        const convertFeature = {
          name,
          create: (Permission.ADD & perms) ? 1 : 0,
          retrieve: (Permission.VIEW & perms) ? 1 : 0,
          update: (Permission.EDIT & perms) ? 1 : 0,
          delete: (Permission.DELETE & perms) ? 1 : 0,
          validate: (Permission.VALIDATE & perms) ? 1 : 0,
          override: (Permission.OVERRIDE & perms) ? 1 : 0,
        }
        return convertFeature
      })
      return module
    })
  }
}
